<!--业主添加和修改弹窗-->
<template>
	<div style="width:100%;display:flex;">
		<el-select v-model="type" placeholder="类型" style="width:25%">
			<el-option v-for="it in divideItemTypeList" :key="it.value" :label="it.label" :value="it.value">
			</el-option>
		</el-select>
		<el-select v-model="itemid" placeholder="项目" style="width:25%">
			<el-option v-for="item in divideItemList" v-show="checkType1(item)" :key="item.id" :label="item.name" :value="item.id">
			</el-option>
		</el-select>
		<el-select v-model="item2id" v-show="type == 1" placeholder="内机" style="width:25%">
			<el-option v-for="item in divideItemACList" v-show="checkType2(item)" :key="item.id" :label="item.name" :value="item.id">
			</el-option>
		</el-select>
		<el-input v-show="type != 1" v-model="area" placeholder="面积" style="width:25%"></el-input>
		<el-button @click="delItem">删除</el-button>
	</div>
</template>

<script>
	export default {
		components: {
		},
		props: ['index', 'area', 'type', 'itemid', 'item2id', 'divideItemList', 'divideItemACList'],
		data() {
			return {
				// divideItemList:[],//分摊项目列表
				divideItemTypeList: [{label: '空调', value:'1'},{label: '公共(内部)', value:'2'},{label: '公共(外部)', value:'3'}],
			}
		},
		created() {
		},
		mounted() {},
		destroyed() {},
		computed: {
		},
		watch: {
			area(nv, ov){
				this.$emit("updateItem", this.index, "area", nv);
			},
			type(nv, ov){
				this.$emit("updateItem", this.index, "type", nv);

				this.$emit("updateItem", this.index, "itemid", nv);
				this.$emit("updateItem", this.index, "item2id", nv);

				this.itemid = '';
				this.item2id = '';
			},
			itemid(nv, ov){
				this.$emit("updateItem", this.index, "itemid", nv);

				this.$emit("updateItem", this.index, "item2id", nv);
				this.item2id = '';
			},
			item2id(nv, ov){
				this.$emit("updateItem", this.index, "item2id", nv);
			},
		},
		methods: {
			delItem(){
				this.$emit("delete", this.index);
			},
			checkType1(item){
				return this.type == item['type'];
			},
			checkType2(item){
				return this.itemid == item['pid'];
			},
		}
	}
</script>